/**
 * @generated SignedSource<<06d91196d6fd583700fc4ad1f67ec549>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContractsTooltip_person$data = {
  readonly contracts: ReadonlyArray<{
    readonly end_date: string | null | undefined;
    readonly id: number;
    readonly start_date: string | null | undefined;
  }>;
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"PersonSidePanel_person">;
  readonly " $fragmentType": "ContractsTooltip_person";
};
export type ContractsTooltip_person$key = {
  readonly " $data"?: ContractsTooltip_person$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContractsTooltip_person">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContractsTooltip_person",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "contracts",
      "kind": "LinkedField",
      "name": "contracts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "start_date",
          "args": null,
          "kind": "ScalarField",
          "name": "start_date_runn",
          "storageKey": null
        },
        {
          "alias": "end_date",
          "args": null,
          "kind": "ScalarField",
          "name": "end_date_runn",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonSidePanel_person"
    }
  ],
  "type": "people",
  "abstractKey": null
};
})();

(node as any).hash = "fbc7c40788e7175f0716da3ca3670deb";

export default node;
